import { gql } from "@apollo/client";

// The signed-in session: who the token belongs to. Exactly one of user /
// student comes back, matching `kind` ("USER" for staff, "STUDENT").
//
// The user fields are the ones the admin UI has always read off its user —
// rol.permissions for isAvailable(), headquarters for the sede switcher,
// userBoxRelations for the caja pickers — so nothing downstream changes.
export const GET_SESSION = gql`
  query meResolver {
    meResolver {
      kind
      user {
        _id
        name
        username
        email
        type
        rol {
          _id
          name
          isAdmin
          permissions {
            students
            instructors
            courses
            courseTurns
            moves
            settings
            users
            stats
            transfers
            mpRefunds
          }
        }
        headquarters {
          headquarterId
          name
          code
          isDefault
        }
        userBoxRelations {
          _id
          isActive
          accountBoxData {
            _id
            name
            type
            isTesoreria
          }
        }
      }
      student {
        _id
        dni
        fullName
        email
        headquarterId
      }
    }
  }
`;
